import React from 'react';
import './AddressEditor.css';

const AddressEditor = ({ addresses = [], onChange }) => {
  const addAddress = () => {
    onChange([...addresses, {
      street_address: '',
      city: '',
      state: '',
      zip_code: '',
      country: 'USA',
      is_primary: addresses.length === 0,
      label: ''
    }]);
  };

  const removeAddress = (index) => {
    const newAddresses = addresses.filter((_, i) => i !== index);
    // If we removed the primary address and there are still addresses left, make the first one primary
    if (newAddresses.length > 0 && !newAddresses.some(a => a.is_primary)) {
      newAddresses[0].is_primary = true;
    }
    onChange(newAddresses);
  };

  const updateAddress = (index, field, value) => {
    const newAddresses = [...addresses];
    newAddresses[index] = { ...newAddresses[index], [field]: value };
    
    // If setting an address as primary, unset other addresses
    if (field === 'is_primary' && value === true) {
      newAddresses.forEach((address, i) => {
        if (i !== index) {
          address.is_primary = false;
        }
      });
    }
    
    onChange(newAddresses);
  };

  return (
    <div className="address-editor">
      <div className="address-editor-header">
        <label>Addresses</label>
        <button 
          type="button" 
          className="btn btn-sm btn-outline"
          onClick={addAddress}
        >
          + Add Address
        </button>
      </div>
      
      {addresses.length === 0 && (
        <p className="text-muted">No addresses added</p>
      )}
      
      {addresses.map((address, index) => (
        <div key={index} className="address-entry">
          <div className="address-entry-fields">
            <div className="form-group address-full-width">
              <label htmlFor={`street-${index}`}>Street Address</label>
              <input
                type="text"
                id={`street-${index}`}
                value={address.street_address}
                onChange={(e) => updateAddress(index, 'street_address', e.target.value)}
                placeholder="123 Main Street"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor={`city-${index}`}>City</label>
              <input
                type="text"
                id={`city-${index}`}
                value={address.city}
                onChange={(e) => updateAddress(index, 'city', e.target.value)}
                placeholder="Springfield"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor={`state-${index}`}>State</label>
              <input
                type="text"
                id={`state-${index}`}
                value={address.state}
                onChange={(e) => updateAddress(index, 'state', e.target.value)}
                placeholder="IL"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor={`zip-${index}`}>Zip Code</label>
              <input
                type="text"
                id={`zip-${index}`}
                value={address.zip_code}
                onChange={(e) => updateAddress(index, 'zip_code', e.target.value)}
                placeholder="62701"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor={`country-${index}`}>Country</label>
              <input
                type="text"
                id={`country-${index}`}
                value={address.country}
                onChange={(e) => updateAddress(index, 'country', e.target.value)}
                placeholder="USA"
              />
            </div>
            
            <div className="form-group address-full-width">
              <label htmlFor={`address-label-${index}`}>Label (Optional)</label>
              <input
                type="text"
                id={`address-label-${index}`}
                value={address.label}
                onChange={(e) => updateAddress(index, 'label', e.target.value)}
                placeholder="e.g., Home, Business, Mailing"
              />
            </div>
            
            <div className="form-group form-group-checkbox">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={address.is_primary}
                  onChange={(e) => updateAddress(index, 'is_primary', e.target.checked)}
                />
                <span>Primary</span>
              </label>
            </div>
          </div>
          
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => removeAddress(index)}
            title="Remove address"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default AddressEditor;
